import { css } from '@emotion/react';

export const sidebarCSS = () => css`
    width: 72px;
    flex-shrink: 0;
    background: #fff;
    border-right: 1px solid var(--pei-line-soft);
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    gap: 6px;
    transition: width 250ms ease, box-shadow 250ms ease;
    position: relative;
    z-index: 5;
    font-family: var(--pei-font);
    overflow: hidden;

    &:hover {
        width: 232px;
        box-shadow: 4px 0 18px rgba(15, 23, 42, 0.06);
    }

    .sb-group {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .sb-eyebrow {
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        color: var(--pei-text-muted);
        text-transform: uppercase;
        padding: 12px 0 6px 24px;
        opacity: 0;
        transition: opacity 200ms ease;
        white-space: nowrap;
    }

    &:hover .sb-eyebrow {
        opacity: 1;
    }

    .sb-items {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .sb-item {
        width: calc(100% - 14px);
        margin: 0 7px;
        height: 42px;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        background: transparent;
        color: var(--pei-text-label);
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0 16px;
        font-size: 13.5px;
        font-weight: 500;
        font-family: inherit;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        transition: background 120ms ease, color 120ms ease;

        .sb-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 16px;
            color: var(--pei-text-label);
            transition: color 120ms ease;

            i {
                font-size: 16px;
            }
        }

        .sb-label {
            flex: 1;
            opacity: 0;
            transition: opacity 200ms ease;
        }

        &:hover:not(.is-active) {
            background: var(--pei-bg-soft);
        }

        &.is-active {
            background: rgba(50, 184, 223, 0.10);
            color: var(--pei-cyan);

            .sb-icon {
                color: var(--pei-cyan);
            }
        }

        &:focus-visible {
            outline: none;
            box-shadow: 0 0 0 2px rgba(52, 198, 241, 0.25);
        }
    }

    &:hover .sb-label {
        opacity: 1;
    }

    .sb-push {
        flex: 1;
    }

    .sb-footer {
        width: calc(100% - 14px);
        margin: 0 7px;
        padding-top: 10px;
        padding-left: 8px;
        border-top: 1px solid var(--pei-line-soft);
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .sb-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: linear-gradient(135deg, var(--pei-cyan), #00BA6E);
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        display: grid;
        place-items: center;
        flex-shrink: 0;
    }

    .sb-user {
        min-width: 0;
        font-size: 12px;
        opacity: 0;
        transition: opacity 200ms ease;
        white-space: nowrap;
        overflow: hidden;
    }

    &:hover .sb-user {
        opacity: 1;
    }

    .sb-user-name {
        font-weight: 500;
        color: var(--pei-text);
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .sb-user-role {
        color: var(--pei-text-helper);
        font-size: 11px;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        .sb-label,
        .sb-eyebrow,
        .sb-user,
        .sb-item,
        .sb-icon {
            transition: none;
        }
    }

    @media (max-width: 1023px) {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 280px;
        z-index: 60;
        transform: translateX(-100%);
        transition: transform 250ms ease;
        box-shadow: 4px 0 18px rgba(15, 23, 42, 0.12);

        &:hover {
            width: 280px;
            box-shadow: 4px 0 18px rgba(15, 23, 42, 0.12);
        }

        &.is-mobile-open {
            transform: translateX(0);
        }

        .sb-label,
        .sb-eyebrow,
        .sb-user {
            opacity: 1;
        }

        @media (prefers-reduced-motion: reduce) {
            transition: none;
        }
    }
`;

export const sidebarOverlayCSS = () => css`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.4);
    z-index: 55;
    animation: sidebarOverlayFadeIn 200ms ease;

    @keyframes sidebarOverlayFadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @media (min-width: 1024px) {
        display: none;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;
